/* eslint-disable  */

// ** React Imports
import { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getHomeRouteForLoggedInUser } from "@utils";
// ** Custom Components
import { handleLogin } from "@store/authentication";
import { AbilityContext } from "@src/utility/context/Can";

import Avatar from "@components/avatar";

// ** Utils
import { isUserLoggedIn } from "@utils";

// ** Store & Actions
import { useDispatch, useSelector } from "react-redux";
import { handleLogout } from "@store/authentication";

import { removeMenu } from "@store/layout";
// ** Third Party Components
import {
  User,
  Mail,
  CheckSquare,
  MessageSquare,
  Settings,
  CreditCard,
  HelpCircle,
  Power,
  Trash,
} from "react-feather";
import toast from "react-hot-toast";

// ** Reactstrap Imports
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";

// ** Default Avatar Image
import defaultAvatar from "@src/assets/images/portrait/small/user.png";
import { unsetAuthToken } from "@api/_api";
import { account } from "@api/Api";

const UserDropdown = () => {
  // ** Store Vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  // ** State
  const [userData, setUserData] = useState(null);
  const location = useLocation();
  //** ComponentDidMount
  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") &&
      localStorage.getItem("accessToken");
    if (!token) {
      return;
    }
    getMe();
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem("userData")));
    }
  }, []);

  const getMe = async () => {
    try {
      const { data, status } = await account.getMe();
      if (status !== 200) {
        return;
      }
      // setUserData(data.data);

      const newData = {
        ...data.data,
        accessToken: data.data.Token,
        refreshToken: data.data.Token,
        ability: [{ action: "manage", subject: "all" }],
      };
      setUserData(newData);
      localStorage.setItem("userData", JSON.stringify(newData));
      const currentPath = location.pathname;

      if (
        data?.data?.contractStatus === 1 ||
        data?.data?.contractStatus === 4
      ) {
        if (data?.data?.roleID?.key === "saleAgent") {
          if (currentPath !== "/apps/ContractSeeLib") {
            dispatch(handleLogout());
            dispatch(removeMenu());
            localStorage.removeItem("menu");

            navigate("/login");
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  //** Vars
  const userAvatar = (userData && userData.picture) || defaultAvatar;

  const anotherUsers = JSON.parse(localStorage.getItem("anotherUser")) || [];

  const handleClickAnotherUser = async (setData) => {
    try {
      const newData = {
        ...setData.userData,
        accessToken: setData.Token,
        refreshToken: setData.Token,
        isActive: true,
        ability: [{ action: "manage", subject: "all" }],
      };

      dispatch(handleLogin(newData));
      ability.update(newData.ability);
      localStorage.setItem("userData", JSON.stringify(newData));
      navigate(getHomeRouteForLoggedInUser(setData.userData?.roleID?.name));
      toast.success("User login successfuly");
      localStorage.removeItem("menu");
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = (item, index) => {
    const newAnotherUsers = anotherUsers.filter((i, idx) => idx !== index);
    localStorage.setItem("anotherUser", JSON.stringify(newAnotherUsers));
    window.location.reload();
  };

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex d-none">
          <span className="user-name fw-bold">
            {(userData && userData["fullName"]) ||
              (userData && userData["faceBookName"]) ||
              "Dear guest"}
          </span>
          <span className="user-status">
            {userData && userData?.roleID?.name}
          </span>
        </div>
        <Avatar img={userAvatar} imgHeight="40" imgWidth="40" status="online" />
      </DropdownToggle>
      <DropdownMenu end>
        {anotherUsers.length > 0 ? (
          <>
            {anotherUsers
              .filter((x) => {
                return x?.userData?.email !== userData?.email;
              })
              .map((item, index) => {
                return (
                  <DropdownItem>
                    <User size={14} className="me-75" />
                    <span
                      onClick={() => handleClickAnotherUser(item)}
                      className="align-middle"
                    >
                      {item.userData.fullName}
                      {item.isSuper ? (
                        <></>
                      ) : (
                        <span className="pl-2">
                          <Trash
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(item, index);
                            }}
                          />
                        </span>
                      )}
                      <br />
                      <small className="text-truncate  mb-0 text-red ">
                        {item?.userData?.roleID?.name}
                      </small>
                    </span>
                  </DropdownItem>
                );
              })}
          </>
        ) : (
          ""
        )}

        <DropdownItem tag={Link} to="/pages/account-settings">
          <Settings size={14} className="me-75" />
          <span className="align-middle">Settings</span>
        </DropdownItem>

        <DropdownItem
          tag={Link}
          to="/login"
          onClick={() => {
            dispatch(handleLogout());
            dispatch(removeMenu());
            localStorage.removeItem("menu");
            unsetAuthToken();
          }}
        >
          <Power size={14} className="me-75" />
          <span className="align-middle">Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
